import { FormControl, InputLabel, MenuItem, Select, IconButton, Icon, DialogContent, DialogActions, Button, DialogContentText, Typography } from "@material-ui/core";
import { makeStyles } from "@material-ui/styles";
import React from "react";
import { useTranslation } from "react-i18next";
import axios from "axios";
import { Dialog } from "@material-ui/core";
import DialogTitleWithClose from "../../components/DialogTitleWithClose";
import { TextField } from "@material-ui/core";
import { Autocomplete, FilterOptionsState } from "@material-ui/lab";
import { ICompanyListItem, IConfigurationResult, ICreateNewLoginRequest, ICreateNewLoginResult, IGetNextNumberByPrefixResult, IOrganisationUnitListItem } from "./Models";
import { IResourceListItem } from "../../../workflow/controls/ResourcesControl/Models";
import clsx from "clsx";

const useStyles = makeStyles((theme) => ({
    loginGeneratorControl: {
        marginBottom: "14px",
    },
    loginGeneratorRow: {
        display: "flex"
    },
    loginGeneratorRowControl: {
        flex: "1"
    }
}));

export interface ILoginGeneratorConfig {
    // Filtruje firmy generatora według firmy pracownika w LOG
    personCompany: boolean;

    // Filtruje po id (tylko określona firma dla przepływu)
    lgCompanyId: string;
}

export interface IChangeAdditionalDataArgs {
    login: string,
    organisationUnit: IOrganisationUnitListItem | string,
    referenceNumber: string,
}

interface ILoginGeneratorDialogProps {
    applicationId: number;
    onClose: (req?: IChangeAdditionalDataArgs) => void;
    employeeId: number;
    configuration: IConfigurationResult;
    organisationUnits: IOrganisationUnitListItem[];
    loginGeneratorConfig: ILoginGeneratorConfig;
}

export function LoginGeneratorDialog(props: ILoginGeneratorDialogProps) {
    const { t } = useTranslation();
    const classes = useStyles();

    const [login, setLogin] = React.useState("");
    const [referenceNumber, setReferenceNumber] = React.useState("");
    const [organisationUnit, setOrganisationUnit] = React.useState<string | NonNullable<IOrganisationUnitListItem>>("");

    const [organizationUnitError, setOrganisationUnitError] = React.useState<string>("");

    const [createResult, setCreateResult] = React.useState<ICreateNewLoginResult>(null);
    const [companies, setCompanies] = React.useState<ICompanyListItem[]>([]);
    const [selectedCompanyId, setSelectedCompanyId] = React.useState<string>("");
    const [selectedCompanyMethod, setSelectedCompanyMethod] = React.useState<string>("");
    
    React.useEffect(() => {
        onRefreshClick();
    }, [selectedCompanyMethod, selectedCompanyId]);

    function setLoginByPrefix(prefix: string) {
        if (!prefix)
            return;

        (async () => {
            const prefixWithYear = prefix + (new Date()).getFullYear().toString().substr(2);
            const response = await axios.get<IGetNextNumberByPrefixResult>("/LoginsGenerator/GetNextNumberByPrefix/?applicationId=" + props.applicationId + "&prefix=" + decodeURIComponent(prefixWithYear));

            let formattedNumber = response.data.nextNumber.toLocaleString('en-US', {
                minimumIntegerDigits: 4,
                useGrouping: false
            })

            setLogin(prefixWithYear + formattedNumber);
        })();
    }

    React.useEffect(() => {
        let active = true;
        if (props.employeeId > 0) {
            if (props.configuration?.method === 'Surname') {
                (async () => {
                    const response = await axios.get<IResourceListItem>("/Resources/GetResourceByLogId/?logId=" + props.employeeId);

                    if (active) {
                        setLogin(surnameToLogin(response.data));
                    }
                })();
            }
            if (props.configuration?.method === 'PersonEmail') {
                (async () => {
                    const response = await axios.get<IResourceListItem>("/Resources/GetResourceByLogId/?logId=" + props.employeeId);

                    if (active) {
                        setLogin(response.data.Email);
                    }
                })();
            }
            if (props.configuration?.method === 'SAPId') {
                (async () => {
                    const response = await axios.get<IResourceListItem>("/Resources/GetResourceByLogId/?logId=" + props.employeeId);

                    if (active) {
                        setLogin(response.data.SAPId);
                    }
                })();
            }
            if (props.configuration?.method === 'HRId') {
                (async () => {
                    const response = await axios.get<IResourceListItem>("/Resources/GetResourceByLogId/?logId=" + props.employeeId);

                    if (active) {
                        setLogin(response.data.HRId);
                    }
                })();
            }
        }

        if (props.configuration?.method === 'Prefix') {
            (async () => {

                let employeeId = '';
                if (props.loginGeneratorConfig?.personCompany === true) {
                    employeeId = props.employeeId.toString();
                }
                let id = '';
                if (props.loginGeneratorConfig?.lgCompanyId) {
                    id = props.loginGeneratorConfig?.lgCompanyId;
                }
                const response = await axios.get<ICompanyListItem[]>("/LoginsGenerator/GetCompanies/?employeeId=" + employeeId + "&id=" + id);

                if (active) {
                    setCompanies(response.data);
                    setLogin("");
                    if (response.data.length === 1) {
                        setSelectedCompanyId(response.data[0].id);
                        setSelectedCompanyMethod("");
                    }
                }
            })();
        }
       
        return () => {
            active = false;
        };
    }, [props.configuration?.method]);

    function surnameToLogin(employee: IResourceListItem): string {

        const surname = clearSpecjalCharacters(employee.Surname);
        const givenName = clearSpecjalCharacters(employee.GivenName);

        let login = "";
        if (givenName) {
            login += givenName[0];
        }

        if (surname) {
            login += surname;
        }

        return login;
    }

    function clearSpecjalCharacters(source: string): string {
        if (!source) {
            return "";
        }
        source = source.toUpperCase();
        let target = "";
        for (let i = 0; i < source.length; i++) {
            const char = source[i];
            if ("A" <= char && "Z" >= char) {
                target += char;
                continue;
            }
            if (char === "Ą") {
                target += "A";
                continue;
            }
            if (char === "Ć") {
                target += "C";
                continue;
            }
            if (char === "Ę") {
                target += "E";
                continue;
            }
            if (char === "Ł") {
                target += "L";
                continue;
            }
            if (char === "Ń") {
                target += "N";
                continue;
            }
            if (char === "Ó") {
                target += "O";
                continue;
            }
            if (char === "Ś") {
                target += "S";
                continue;
            }
            if (char === "Ź" || char === "Ż") {
                target += "Z";
                continue;
            }
        }

        return target;
    }

    function onRefreshClick() {
        if (selectedCompanyMethod === 'testLogin') {
            setLoginByPrefix("TESTER");
        };

        if (selectedCompanyMethod === '') {
            const company = companies.find(x => x.id == selectedCompanyId);
            if (company) {
                setLoginByPrefix(company.loginPrefix);
            }
        };
    }

    function onSave() {

        (async () => {

            if (!isValidForm()) {
                return;
            }

            let organizationUnitId: string | null = null;
            if (organisationUnit && typeof (organisationUnit) === 'object') {
                organizationUnitId = organisationUnit?.id;
            }

            const request: ICreateNewLoginRequest = {
                Login: prepareLogin(login),
                OrganizationUnitId: organizationUnitId,
                ReferenceNumber: referenceNumber,
                PersonId: props.employeeId,
                ApplicationId: props.applicationId,
            }

            const response = await axios.post<ICreateNewLoginResult>("/LoginsGenerator/CreateNewLogin/", request);
            setCreateResult(response.data);
            if (response.data?.success) {

                const args: IChangeAdditionalDataArgs = {
                    login: request.Login,
                    organisationUnit: organisationUnit,
                    referenceNumber: request.ReferenceNumber,
                }
                props.onClose(args);
            }
        })();
    }

    function isValidForm(): boolean {
        let organisationUnitError = "";

        if (props.configuration?.useOrganisationUnit) {
            if (!organisationUnit || typeof organisationUnit !== 'object')
                organisationUnitError = t("Pole jest wymagane");
        }

        setOrganisationUnitError(organisationUnitError);

        return !organisationUnitError;
    }

    function prepareLogin(source: string): string {
        if (!source) {
            return "";
        }

        let allowDot = false;
        let allowAll = false;

        if (props.configuration?.method === 'SAPId' || props.configuration?.method === 'HRId') {
            source = source.toLowerCase();
            allowDot = true;
        }
        if (props.configuration?.method === 'PersonEmail') {
            allowDot = true;
            allowAll = true;
        }
        if (props.configuration?.method === 'Surname' || props.configuration?.method === 'Prefix') {
            source = source.toUpperCase();
        }

        let target = "";
        for (let i = 0; i < source.length; i++) {
            const char = source[i];
            if (char === "ą") {
                target += "a";
                continue;
            }
            if (char === "Ą") {
                target += "A";
                continue;
            }
            if (char === "ć") {
                target += "c";
                continue;
            }
            if (char === "Ć") {
                target += "C";
                continue;
            }
            if (char === "ę") {
                target += "e";
                continue;
            }
            if (char === "Ę") {
                target += "E";
                continue;
            }
            if (char === "ł") {
                target += "l";
                continue;
            }
            if (char === "Ł") {
                target += "L";
                continue;
            }
            if (char === "ń") {
                target += "n";
                continue;
            }
            if (char === "Ń") {
                target += "N";
                continue;
            }
            if (char === "ó") {
                target += "o";
                continue;
            }
            if (char === "Ó") {
                target += "O";
                continue;
            }
            if (char === "ś") {
                target += "s";
                continue;
            }
            if (char === "Ś") {
                target += "S";
                continue;
            }
            if (char === "ź" || char === "ż") {
                target += "z";
                continue;
            }
            if (char === "Ż" || char === "Ź") {
                target += "Z";
                continue;
            }

            if ((char >= 'a' && char <= 'z'))
                target += char;
            if ((char >= 'A' && char <= 'Z'))
                target += char;
            if ((char >= '0' && char <= '9'))
                target += char;

            if (allowDot) {
                if (char === ".") {
                    target += char;
                    continue;
                }
            }

            if (allowAll) {
                var allowedChars = '+@._-/';
                if (allowedChars.indexOf(char) > -1)
                    target += char;
            }
        }

        return target;
    }

    function prepareReferenceNumber(source: string): string {
        if (!source) {
            return "";
        }
        let target = "";
        for (let i = 0; i < source.length; i++) {
            const char = source[i];
            const charLow = char.toLowerCase();
            if (charLow === "ą") {
                continue;
            }
            if (charLow === "ć") {
                continue;
            }
            if (charLow === "ę") {
                continue;
            }
            if (charLow === "ł") {
                continue;
            }
            if (charLow === "ń") {
                continue;
            }
            if (charLow === "ó") {
                continue;
            }
            if (charLow === "ś") {
                continue;
            }
            if (charLow === "ź" || charLow === "ż") {
                continue;
            }

            target += char;
        }

        return target.substr(0, 10);
    }

    let allowSystemLogin = false;
    let allowTestLogin = false;

    if (selectedCompanyId) {
        const selectedCompany = companies.find(x => x.id === selectedCompanyId);

        allowSystemLogin = selectedCompany?.allowSystemLogin ?? false;
        allowTestLogin = selectedCompany?.allowTestLogin ?? false;
    }
    const anyEditingLogin =
        props.configuration?.method !== 'Prefix'
    return <Dialog
        open={true}
        onClose={() => props.onClose()}
    >
        <DialogTitleWithClose
            onClose={() => props.onClose()}
        >
            {t('control.loginsGenerator.dialogTitle')}
        </DialogTitleWithClose>
        <DialogContent>
            {!props.configuration && <DialogContentText>
                {t('control.loginsGenerator.noConfiguration')}
            </DialogContentText>}

            {createResult?.errorMessage && <Typography color="error">
                {t('control.loginsGenerator.' + createResult.errorMessage)}
            </Typography>}
            
            {anyEditingLogin && <div>
                <TextField
                    className={classes.loginGeneratorControl}
                    label="Login"
                    type="text"
                    value={login}
                    onChange={(e) => setLogin(prepareLogin(e.target.value))}

                    variant="outlined"
                    fullWidth
                />
            </div>}

            {props.configuration?.method === 'Prefix' && <div>
                {(companies?.length !== 1) && <FormControl className={classes.loginGeneratorControl} variant="outlined" fullWidth>
                    <InputLabel id='test-select-label'>{t("control.loginsGenerator.selectedCompanyId")}</InputLabel>
                    <Select
                        labelId='test-select-label'
                        value={selectedCompanyId}
                        onChange={x => {
                            setSelectedCompanyId(x.target.value as string);
                            setSelectedCompanyMethod("");
                            setLogin("");
                        }}
                        label={t("control.loginsGenerator.selectedCompanyId")}
                    >
                        <MenuItem value="">
                            <em>{t("control.loginsGenerator.none")}</em>
                        </MenuItem>
                        {companies.map(x => {
                            return <MenuItem key={x.id} value={x.id}>
                                {x.name}
                            </MenuItem>
                        })}
                    </Select>
                </FormControl>}

                {(allowSystemLogin || allowTestLogin) && <FormControl
                    className={classes.loginGeneratorControl}
                    variant="outlined"
                    fullWidth
                >
                    <InputLabel id='test-select-label'>{t("control.loginsGenerator.loginKind")}</InputLabel>
                    <Select
                        value={selectedCompanyMethod}
                        onChange={x => {
                            setSelectedCompanyMethod(x.target.value as string);
                            setLogin("");
                        }}
                        label={t("control.loginsGenerator.loginKind")}
                    >
                        <MenuItem value="">
                            <em>{t("control.loginsGenerator.standard")}</em>
                        </MenuItem>
                        {allowSystemLogin && <MenuItem value={"systemLogin"}>
                            {t("control.loginsGenerator.systemLogin")}
                        </MenuItem>}
                        {allowTestLogin && <MenuItem value={"testLogin"}>
                            {t("control.loginsGenerator.testLogin")}
                        </MenuItem>}
                    </Select>
                </FormControl>}
                <div className={clsx(classes.loginGeneratorControl, classes.loginGeneratorRow)} >
                    <TextField
                        className={clsx(classes.loginGeneratorRowControl)}
                        disabled={selectedCompanyMethod === '' || selectedCompanyMethod === 'testLogin'}
                        label="Login"
                        InputProps={{
                            className: "dsdsds",
                        }}
                        type="text"
                        value={login}
                        onChange={(e) => setLogin(prepareLogin(e.target.value))}

                        variant="outlined"
                        fullWidth
                    />
                    {(selectedCompanyMethod === '' || selectedCompanyMethod === 'testLogin') && <div>
                        <IconButton
                            title={t('control.loginsGenerator.refreshBtn')}
                            onClick={() => onRefreshClick()}
                        >
                            <Icon>refresh</Icon>
                        </IconButton>
                    </div>}
                </div>
            </div>}

            {props.configuration?.useOrganisationUnit && <div
                className={classes.loginGeneratorControl}
            >
                <Autocomplete
                    value={organisationUnit}
                    onChange={(event, newValue) => {
                        setOrganisationUnit(newValue as any);
                        setOrganisationUnitError("");
                    }}

                    options={props.organisationUnits}
                    loading={false}
                    autoComplete

                    clearText={t("common.action.clear")}
                    noOptionsText={t("control.autocomplete.noOptionsMessage")}
                    openText={t("common.action.open")}
                    closeText={t("common.action.close")}
                    loadingText={t("common.loading") + "..."}

                    getOptionLabel={(option: IOrganisationUnitListItem) => {
                        let label = option?.name ?? "";
                        if (option?.number) {
                            label + " (" + option.number + ")"
                        }
                        return label;
                    }}

                    renderInput={params => (
                        <TextField
                            {...params}
                            error={!!organizationUnitError}
                            helperText={organizationUnitError}
                            variant="outlined"
                            fullWidth
                            label={t('control.loginsGenerator.organizationUnit')}
                            InputProps={{
                                ...params.InputProps,
                                autoComplete: 'disabled',
                                endAdornment: (
                                    <React.Fragment>
                                        {organisationUnit && typeof organisationUnit === 'object' && <span title="Numer jednostki">{organisationUnit?.number}</span>}
                                        {/*{isLoading ? <CircularProgress color="inherit" size={20} /> : null}*/}
                                        {params.InputProps.endAdornment}
                                    </React.Fragment>
                                ),
                            }}
                        />
                    )}

                    renderOption={(option: IOrganisationUnitListItem) => {
                        return <div>
                            <Typography variant="body2" color="textPrimary">
                                {option.name}&nbsp;({option.number})
                            </Typography>
                            <Typography variant="body2" color="textSecondary">
                                {option.description}
                            </Typography>
                        </div>
                    }}

                    filterOptions={(options: IOrganisationUnitListItem[], state: FilterOptionsState<IOrganisationUnitListItem>) => {
                        let search = state.inputValue;
                        if (!search)
                            return options;
                        search = search.toLocaleLowerCase();
                        return options.filter((x) => (x.number && x.number.toLocaleLowerCase().indexOf(search) > -1) || (x.name && x.name.toLocaleLowerCase().indexOf(search) > -1));
                    }}
                />
            </div>}

            {props.configuration?.useReferenceNumber && <div>
                <TextField
                    className={classes.loginGeneratorControl}
                    label={t('control.loginsGenerator.referenceNumber')}
                    InputProps={{
                        className: "dsdsds",
                    }}
                    type="text"
                    value={referenceNumber}
                    onChange={(e) => setReferenceNumber(prepareReferenceNumber(e.target.value))}
                    variant="outlined"
                    fullWidth
                />
            </div>}

        </DialogContent>
        <DialogActions>
            <Button onClick={() => props.onClose()} color="default">
                {t("common.action.cancel")}
            </Button>
            {props.employeeId !== 0 && <Button onClick={onSave} color="primary" variant="contained">
                {t("common.action.save")}
            </Button>}
        </DialogActions>
    </Dialog>
}